import React, { useState } from "react";
import "./ModalPopup.css"; // Import CSS for styling

const ModalPopup = ({isOpen,closeModal,betData,session,gameName,handleSubmit}) => {
    
  return (
    <div>
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2 style={{marginLeft:'34%'}}>{gameName.split('_').join(' ')}</h2>
              <button className="close-btn" onClick={closeModal}>
                &#x2715;
              </button>
            </div>
<div style={{overflowY:'auto',maxHeight:'300px'}}>
            {/* Table Section */}
            <table className="modal-table">
              <thead>
                <tr>
                  <th>Digits</th>
                  <th>Points</th>
                  <th>Game Type</th>
                  <th>Bid status</th>
                </tr>
              </thead>
              <tbody>
              {
                betData.map((key,index) => (

                    <tr key={index}>
                    <td>{key.sangam}</td>
                    <td>{key.points}</td>
                    <td>{session}</td>
                    <td>{key.error||'HOLD'}</td>
                  </tr>

                ))}
               
               
              </tbody>
            </table>
</div>
            <p className="note">*Note Bid Once Played Will Not Be Cancelled*</p>

           {/* Footer Section */}
           <div className="modal-footer">
              
              <div className="footer-buttons modal_button">
                <button className="continue-button" style={{color:'red',backgroundColor:'white',boxShadow:'#ff000078 1px 1px 1px 1px'}} onClick={closeModal}>
                  Cancel
                </button>
                <button className="continue-button" onClick={handleSubmit}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalPopup;
